<script setup>
import DeviceManage from "@/components/device/DeviceManage.vue";
import {useTitle} from "@/utils/metadata";

useTitle(pgettext('title', 'Authorized Devices'));
</script>

<template>
    <DeviceManage/>
</template>
